import { render, staticRenderFns } from "./FullscreenDialog.vue?vue&type=template&id=27c5f6d4&scoped=true"
import script from "./FullscreenDialog.vue?vue&type=script&lang=js"
export * from "./FullscreenDialog.vue?vue&type=script&lang=js"
import style0 from "./FullscreenDialog.vue?vue&type=style&index=0&id=27c5f6d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c5f6d4",
  null
  
)

export default component.exports